// utils/firebaseUtils.js

// 1. All imports must be at the very top
import { 
  ref, 
  uploadBytes, 
  getDownloadURL, 
  uploadBytesResumable 
} from "firebase/storage";


// Import your initialized storage instance
import { storage } from "../firebase";

/**
 * Uploads a file to Firebase Storage and returns the Download URL.
 * @param {File} file - The file object from the input
 * @param {string} path - The folder path (e.g., 'amc_evidence')
 */
export const uploadFileToFirebase = async (file, path = "amc_evidence") => {
  try {
    // Create a unique filename to prevent overwrites
    const uniqueName = `${Date.now()}_${file.name}`;
    const storageRef = ref(storage, `${path}/${uniqueName}`);

    // Upload the file
    const snapshot = await uploadBytes(storageRef, file);

    // Get the public URL
    const downloadURL = await getDownloadURL(snapshot.ref);

    return {
      name: file.name,
      type: file.type,
      url: downloadURL,
      path: snapshot.ref.fullPath, // Useful if you need to delete it later
    };
  } catch (error) {
    console.error("Error uploading file:", error);
    throw error;
  }
};


/**
 * Uploads a file with progress callback and returns metadata + download URL.
 * @param {File} file
 * @param {string} path
 * @param {(percent:number)=>void} onProgress
 */
export const uploadFileWithProgress = (
  file,
  path = "checklists",
  onProgress
) => {
  return new Promise((resolve, reject) => {
    try {
      const uniqueName = `${Date.now()}_${file.name}`;
      const storageRef = ref(storage, `${path}/${uniqueName}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          if (onProgress) onProgress(percent);
        },
        (error) => reject(error),
        async () => {
          try {
            const url = await getDownloadURL(uploadTask.snapshot.ref);
            resolve({
              name: file.name,
              type: file.type,
              url,
              path: uploadTask.snapshot.ref.fullPath,
            });
          } catch (err) {
            reject(err);
          }
        }
      );
    } catch (err) {
      reject(err);
    }
  });
};